export const smoothScroll = (elem, options) => {
  return new Promise((resolve) => {
    if (!(elem instanceof Element)) {
      throw new TypeError("Argument 1 must be an Element");
    }
    let same = 0; // a counter
    let lastPos = null; // last known Y position

    // Overwrite options when element.height is greater than window.
    if (elem.offsetHeight > window.innerHeight) {
      options = {
        block: "start",
      };
    }

    // pass the defined options along with our default
    const scrollOptions = Object.assign({ behavior: "smooth" }, options);

    elem.scrollIntoView(scrollOptions);
    requestAnimationFrame(check);

    // this function will be called every painting frame
    // for the duration of the smooth scroll operation
    function check() {
      // check our current position
      const newPos = elem.getBoundingClientRect().top;

      if (newPos === lastPos) {
        if (same++ > 2) {
          // if it's more than two frames
          return resolve(); // we've come to an halt
        }
      } else {
        same = 0; // reset our counter
        lastPos = newPos; // remember our current position
      }
      // check again next painting frame
      requestAnimationFrame(check);
    }
  });
};

export const htmlModalClass = (open, type) => {
  const html = document.querySelector("html");

  if (open) {
    if (type === "modal") {
      html.classList.add("has-modal-open");
    }
    if (type === "pop-up") {
      html.classList.add("has-pop-up-open");
    }
  } else {
    html.classList.remove("has-modal-open");
    html.classList.remove("has-pop-up-open");
  }
};

export function getMobileIndex(data, slideId) {
  for (let i = 0; i < data.length; i++) {
    const { id } = data[i];
    if (id === slideId) {
      return i;
    }
  }
  return -1;
}

export function debounce(func, time = 100) {
  let timer;
  return function (event) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(func, time, event);
  };
}

export const daysToMilliseconds = (days) => {
  return days * 24 * 60 * 60 * 1000;
};

export function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}
